<ng-container *ngIf="commentsDataRequest$ | async as commentsDataRequest">
  <div
    *ngIf="commentsDataRequest.value && commentsDataRequest.didSucceed"
    class="comments-component-wrapper"
  >
    <app-header>
      <h1 app-title>
        {{ commentsDataRequest?.value.length || 0 }}
        <span>
          {{ commentsDataRequest?.value.length === 1 ? 'Comment' : 'Comments' }}
        </span>
      </h1>
    </app-header>

    <div
      *appIfCommandAvailable="'insert_simulation_comment'"
      class="new-comments-section"
    >
      <div class="new-comments-avatar">
        <img
          class="temporary-user-avatar"
          matListAvatar
          src="{{ user?.metadata?.picture }}"
          onerror="this.src = '../../../../../../assets/dummy/dummy-logo.jpg'"
          alt="User image"
        />
      </div>
      <app-comment-reply
        [accessMode]="accessMode"
        [enableCancel]="false"
        (replied)="
          doActionComment({
            event: 'post',
            comment_reply: $event
          })
        "
      ></app-comment-reply>
    </div>
    <div
      class="comments-list"
      *appVar="userLoggedType$ | async as userLoggedTopRole"
    >
      <div
        *ngFor="let commentItem of displayedComments"
        class="comments-list-comment"
      >
        <app-comment
          [accessMode]="accessMode"
          [comment]="commentItem"
          [user]="stateService.user$ | async"
          [userLoggedTopRole]="userLoggedTopRole"
          (actionComment)="doActionComment($event)"
        >
        </app-comment>
      </div>
    </div>
  </div>
</ng-container>
